import { createSlice } from "@reduxjs/toolkit";
import { current } from "@reduxjs/toolkit";

const initialState = {
  project_scoop_list: [],
  project_scoop_grouped: {},
  tms_summary_jobs: [],
  tms_badge_count: [],
  scoop_badge_count: [],
  upcoming_deliveries: [],
  overdue_jobs: [],
  absent_linguist_list: [],
  job_detail_list: [],
  order_id: "",
  scoop_detail_list: [],
  scoop_client_dd: [],
  scoop_table: [],
  jobChainData: [],
  jobs: [],
  jobTableData: [],
  file_folders: [],
  project_detail: {},
  scoopDetailsForDashboardOverview: {},
  masterDropdownList: {},
  holidayList: {},
  priceListDetailsForCheckTheData: [],
  fileTotal: [],
  priceListForResources: [],
  chat_details: [],
  chat_details_user: [],
  chat_details_user_job: [],
  scoop_dropdown_inchat: [],
  job_dropdown_inchat: [],
  userDashboardTabs: [],
  globalSearch: {},
  dropdowns: [],
  jobDetailsForMailTemplate: {},
  fileTotalForJobs: [],
  job_summary: [],
  sortCriteria: [], // Add sortCriteria to the state
  editing_users: [],
};

const DashboardSlice = createSlice({
  name: "DashboardSlice",
  initialState,
  reducers: {
    setSortCriteria: (state, action) => {
      state.sortCriteria = Array.isArray(action.payload) ? action.payload : [];;
    },
    resetSortCriteria: (state) => {
      state.sortCriteria = [];
    },
    setProjectScoopOrders: (state, action) => ({
      ...state,
      project_scoop_list: action.payload,
    }),
    setProjectScoopGrouped: (state, action) => ({
      ...state,
      project_scoop_grouped: action.payload,
    }),
    setDiscussionScoop: (state, action) => ({
      ...state,
      chat_details: action.payload,
    }),
    setitemsScoopsDropdown: (state, action) => ({
      ...state,
      scoop_dropdown_inchat: action.payload,
    }),
    setselectJobDataByOrderId: (state, action) => ({
      ...state,
      job_dropdown_inchat: action.payload,
    }),
    setdiscussionScoopDetails: (state, action) => ({
      ...state,
      chat_details_user: action.payload,
    }),
    setdiscussionJobDetails: (state, action) => ({
      ...state,
      chat_details_user_job: action.payload,
    }),
    setTmsSummaryJobs: (state, action) => ({
      ...state,
      tms_summary_jobs: action.payload,
    }),
    setTmsSummaryJobsBadge: (state, action) => ({
      ...state,
      tms_badge_count: action.payload,
    }),
    setProjectScoopOrdersBadge: (state, action) => ({
      ...state,
      scoop_badge_count: action.payload,
    }),
    setUpcomingDeliveries: (state, action) => ({
      ...state,
      upcoming_deliveries: action.payload,
    }),
    setOverdueJobs: (state, action) => ({
      ...state,
      overdue_jobs: action.payload,
    }),
    setAbsentLinguistList: (state, action) => ({
      ...state,
      absent_linguist_list: action.payload,
    }),
    setJobDetailChange: (state, action) => ({
      ...state,
      job_detail_list: action.payload,
    }),
    setOrderId: (state, action) => ({
      ...state,
      order_id: action.payload,
    }),
    setFullScoopDetailList: (state, action) => ({
      ...state,
      scoop_detail_list: action.payload,
    }),
    resetFullScoopDetailList: state => ({
      ...state,
      scoop_detail_list: [],
    }),
    setScoopClientDropdown: (state, action) => ({
      ...state,
      scoop_client_dd: action.payload,
    }),
    setScoopTable: (state, action) => ({
      ...state,
      scoop_table: action.payload,
    }),
    setJobChainData: (state, action) => ({
      ...state,
      jobChainData: action.payload,
    }),
    setJobData: (state, action) => ({
      ...state,
      jobs: action.payload,
    }),
    setDataForJobTable: (state, action) => ({
      ...state,
      jobTableData: action.payload,
    }),
    resetJobTableData: state => ({
      ...state,
      jobTableData: [], // or `null` depending on your initial state
    }),
    setFileFolders: (state, action) => ({
      ...state,
      file_folders: action.payload,
    }),
    setProjectDetail: (state, action) => ({
      ...state,
      project_detail: action.payload,
    }),
    resetProjectDetail: state => ({
      ...state,
      project_detail: {},
    }),
    setScoopDetailsForDashboardOverview: (state, action) => ({
      ...state,
      scoopDetailsForDashboardOverview: action.payload,
    }),
    resetScoopDetailsForDashboardOverview: state => ({
      ...state,
      scoopDetailsForDashboardOverview: initialState.scoopDetailsForDashboardOverview,
    }),
    setMasterDropDownList: (state, action) => ({
      ...state,
      masterDropdownList: action.payload,
    }),
    setGlobalSearch: (state, action) => ({
      ...state,
      globalSearch: action.payload,
    }),
    setHoliDayListing: (state, action) => ({
      ...state,
      holidayList: action.payload,
    }),
    setPriceListDetails: (state, action) => {
      const newPayloadItems = Array.isArray(action.payload) ? action.payload : (action.payload ? [action.payload] : []);
      let updatedPriceList = [...state.priceListDetailsForCheckTheData]; // Create a shallow copy

      newPayloadItems.forEach(newItem => {
        const existingIndex = updatedPriceList.findIndex(item => item.item_id === newItem.item_id);

        if (existingIndex !== -1) {
          // Replace existing item immutably
          updatedPriceList = [
            ...updatedPriceList.slice(0, existingIndex),
            newItem,
            ...updatedPriceList.slice(existingIndex + 1),
          ];
        } else {
          // Add new item immutably
          updatedPriceList = [...updatedPriceList, newItem];
        }
      });

      state.priceListDetailsForCheckTheData = updatedPriceList;
    },
    setFileTotal: (state, action) => ({
      ...state,
      fileTotal: action.payload,
    }),
    // setFileTotal: (state, action) => {
    //   if (Array.isArray(action.payload)) {
    //     return {
    //       ...state,
    //       fileTotal: action.payload,
    //     };
    //   } else {
    //     const { item_id, ...rest } = action.payload; // Destructure item_id and other properties
    //     const currentFileTotal = Array.isArray(state.fileTotal) ? [...state.fileTotal] : [];
    //     const index = currentFileTotal.findIndex(item => item.item_id == item_id);
    //     if (index !== -1) {
    //       currentFileTotal[index] = { ...currentFileTotal[index], ...action.payload };
    //     } else {
    //       currentFileTotal.push(action.payload);
    //     }
    //     return {
    //       ...state,
    //       fileTotal: currentFileTotal,
    //     };
    //   }
    // },
    setPriceListForResources: (state, action) => ({
      ...state,
      priceListForResources: action.payload,
    }),
    setUserDashboardTabs: (state, action) => ({
      ...state,
      userDashboardTabs: action.payload,
    }),
    setGeneralMasterDropDownList: (state, action) => ({
      ...state,
      dropdowns: action.payload,
    }),
    setJobDetailsForMailTemplate: (state, action) => ({
      ...state,
      jobDetailsForMailTemplate: action.payload,
    }),
    setFileTotalForJobs: (state, action) => ({
      ...state,
      fileTotalForJobs: action.payload,
    }),
    setJobDetails: (state, action) => ({
      ...state,
      job_summary: action.payload,
    }),
    setEditingUsers: (state, action) => ({
      ...state,
      editing_users: action.payload,
    }),
    setAlertNotification: (state, action) => ({
      ...state,
      alertNotification: action.payload,
    }),
  },
});

export const {
  setGeneralMasterDropDownList,
  setGlobalSearch,
  setProjectScoopOrders,
  setTmsSummaryJobs,
  setTmsSummaryJobsBadge,
  setProjectScoopOrdersBadge,
  setUpcomingDeliveries,
  setOverdueJobs,
  setAbsentLinguistList,
  setJobDetailChange,
  setOrderId,
  setFullScoopDetailList,
  setScoopClientDropdown,
  setScoopTable,
  setPriceListForResources,
  setFileTotal,
  setPriceListDetails,
  resetFullScoopDetailList,
  setJobChainData,
  setJobData,
  setDataForJobTable,
  resetJobTableData,
  setFileFolders,
  setProjectDetail,
  setScoopDetailsForDashboardOverview,
  resetScoopDetailsForDashboardOverview,
  setMasterDropDownList,
  resetProjectDetail,
  setHoliDayListing,
  setDiscussionScoop,
  setdiscussionScoopDetails,
  setdiscussionJobDetails,
  setitemsScoopsDropdown,
  setselectJobDataByOrderId,
  setUserDashboardTabs,
  setJobDetailsForMailTemplate,
  setProjectScoopGrouped,
  setFileTotalForJobs,
  setJobDetails,
  setSortCriteria,
  resetSortCriteria,
  setEditingUsers,
  setAlertNotification
} = DashboardSlice.actions;

export default DashboardSlice.reducer;
